/**
 * Sprint 57 (DT-007) — Destinatarios de los correos de soporte.
 *
 * `email_soporte` guarda una lista separada por comas: el dueño quiere los
 * reportes en más de una cuenta (p. ej. la personal y la de respaldo). Se
 * parsea en un solo lugar para que la UI valide exactamente lo mismo que el
 * backend termina enviando.
 */

/** Formato deliberadamente laxo: valida forma, no existencia del buzón. */
const RE_EMAIL = /^[^\s@,]+@[^\s@,]+\.[^\s@,]{2,}$/;

export function esEmailValido(valor: string): boolean {
  return RE_EMAIL.test(valor.trim());
}

/**
 * Convierte el valor guardado en la lista de destinatarios a usar.
 * Ignora entradas vacías y duplicados (sin importar mayúsculas).
 */
export function parsearDestinatarios(valor: string | null | undefined): string[] {
  if (!valor) return [];
  const vistos = new Set<string>();
  const salida: string[] = [];
  for (const parte of valor.split(/[,;]/)) {
    const email = parte.trim();
    if (!email) continue;
    const clave = email.toLowerCase();
    if (vistos.has(clave)) continue;
    vistos.add(clave);
    salida.push(email);
  }
  return salida;
}

/** Los que NO tienen forma de email, para señalarlos en la UI. */
export function destinatariosInvalidos(valor: string | null | undefined): string[] {
  return parsearDestinatarios(valor).filter((e) => !esEmailValido(e));
}

/** Normaliza para guardar: sin espacios sobrantes ni duplicados. */
export function formatearDestinatarios(valor: string | null | undefined): string {
  return parsearDestinatarios(valor).join(', ');
}
